export const CHANGE_PRODUCTS_HISTORY_FIELD = 'CHANGE_PRODUCTS_HISTORY_FIELD';
export const GET_SETTING_PRODUCTS_HISTORY = 'GET_SETTING_PRODUCTS_HISTORY';
export const GET_SETTING_PRODUCTS_HISTORY_RESULT = 'GET_SETTING_PRODUCTS_HISTORY_RESULT';
export const SAVE_SETTING_PRODUCTS_HISTORY = 'SAVE_SETTING_PRODUCTS_HISTORY';
export const SAVE_SETTING_PRODUCTS_HISTORY_RESULT = 'SAVE_SETTING_PRODUCTS_HISTORY_RESULT';
export const CLEAR_DATA_PRODUCTS_HISTORY = 'CLEAR_DATA_PRODUCTS_HISTORY';

export const CHANGE_PRODUCTS_HISTORY_SETTINGS = 'CHANGE_PRODUCTS_HISTORY_SETTINGS';
export const CHANGE_PRODUCTS_HISTORY_THEME = 'CHANGE_PRODUCTS_HISTORY_THEME';
